import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import WebpublicationShareForm from '../../../components/Share/WebpublicationForm';

const mapStateToProps = (state: StoreState) => {
	const { sharePanel } = state;
	const { selectedResources, isOpen, isProcessing, form } = sharePanel;
	return { selectedResources, isOpen, isProcessing, form };
};

export default connect(mapStateToProps)(WebpublicationShareForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/WebpublicationForm/index.tsx